import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: "app-loan-subcard-info",
    templateUrl: "./loan-subcard-info.component.html",
    styleUrls: ["./loan-subcard-info.component.scss"],
    standalone: false
})
export class LoanSubcardInfoComponent implements OnInit {
  @Input() loandata: any;
  constructor() {}

  ngOnInit(): void {}
}
